<div class="row page-header">
    <div class="col-12">
        <h1>Barcode Manager <small>View reserved barcodes and find the next available barcode</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Barcodes'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <wj-flex-grid id="mainGrid" #mainGrid appAutoSize (initialized)="grid.initialize(mainGrid)" [itemsSource]="grid.view">
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Barcode'" [binding]="'barcode'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Manufacturer'" [binding]="'manufacturer'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Material'" [binding]="'material'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Model'" [binding]="'model'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Retired Date'" [binding]="'retiredDate'" [width]="'*'"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
                <div class="col-4">
                    <h4>Next Available Barcode:</h4>
                    <h3>{{ nextBarcode() }}</h3>
                    <p>Please enter the barcode in Vista and click the button below to ensure there are no duplicates.</p>
                    <button class="btn btn-primary" (click)="reserveNextBarcode()">Reserve Next Barcode</button>
                </div>
            </div>
        </div>
    </div>
</div>
